/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RenterCompanyCreateModel,
    RenterCompanyCreateModelFromJSON,
    RenterCompanyCreateModelFromJSONTyped,
    RenterCompanyCreateModelToJSON,
} from './RenterCompanyCreateModel';

/**
 * 
 * @export
 * @interface SaleRequestFormCreateWithRegisterModel
 */
export interface SaleRequestFormCreateWithRegisterModel {
    /**
     * 
     * @type {boolean}
     * @memberof SaleRequestFormCreateWithRegisterModel
     */
    withRegister: boolean;
    /**
     * 
     * @type {RenterCompanyCreateModel}
     * @memberof SaleRequestFormCreateWithRegisterModel
     */
    renterUser: RenterCompanyCreateModel;
    /**
     * 
     * @type {number}
     * @memberof SaleRequestFormCreateWithRegisterModel
     */
    subCategoryId?: number;
    /**
     * 
     * @type {string}
     * @memberof SaleRequestFormCreateWithRegisterModel
     */
    subCategoryOther?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaleRequestFormCreateWithRegisterModel
     */
    brand?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SaleRequestFormCreateWithRegisterModel
     */
    minProductionYear?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SaleRequestFormCreateWithRegisterModel
     */
    maxProductionYear?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SaleRequestFormCreateWithRegisterModel
     */
    minPrice?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SaleRequestFormCreateWithRegisterModel
     */
    maxPrice?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SaleRequestFormCreateWithRegisterModel
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SaleRequestFormCreateWithRegisterModel
     */
    districtId?: number;
    /**
     * 
     * @type {number}
     * @memberof SaleRequestFormCreateWithRegisterModel
     */
    minOperatingWeight?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SaleRequestFormCreateWithRegisterModel
     */
    maxOperatingWeight?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SaleRequestFormCreateWithRegisterModel
     */
    minOperationHour?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SaleRequestFormCreateWithRegisterModel
     */
    maxOperationHour?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SaleRequestFormCreateWithRegisterModel
     */
    minCarryingCapacity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SaleRequestFormCreateWithRegisterModel
     */
    maxCarryingCapacity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SaleRequestFormCreateWithRegisterModel
     */
    minOperatingHeight?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SaleRequestFormCreateWithRegisterModel
     */
    maxOperatingHeight?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SaleRequestFormCreateWithRegisterModel
     */
    minSpraySpeed?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SaleRequestFormCreateWithRegisterModel
     */
    maxSpraySpeed?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SaleRequestFormCreateWithRegisterModel
     */
    minTankVolume?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SaleRequestFormCreateWithRegisterModel
     */
    maxTankVolume?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SaleRequestFormCreateWithRegisterModel
     */
    minLiftingHeight?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SaleRequestFormCreateWithRegisterModel
     */
    maxLiftingHeight?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SaleRequestFormCreateWithRegisterModel
     */
    minOperationMileage?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SaleRequestFormCreateWithRegisterModel
     */
    maxOperationMileage?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SaleRequestFormCreateWithRegisterModel
     */
    minNoMinalCapacity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SaleRequestFormCreateWithRegisterModel
     */
    maxNoMinalCapacity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SaleRequestFormCreateWithRegisterModel
     */
    minHeight?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SaleRequestFormCreateWithRegisterModel
     */
    maxHeight?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SaleRequestFormCreateWithRegisterModel
     */
    minEnginePower?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SaleRequestFormCreateWithRegisterModel
     */
    maxEnginePower?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SaleRequestFormCreateWithRegisterModel
     */
    minMaxPower?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SaleRequestFormCreateWithRegisterModel
     */
    maxMaxPower?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SaleRequestFormCreateWithRegisterModel
     */
    minVolume?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SaleRequestFormCreateWithRegisterModel
     */
    maxVolume?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SaleRequestFormCreateWithRegisterModel
     */
    minTankCapacity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SaleRequestFormCreateWithRegisterModel
     */
    maxTankCapacity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SaleRequestFormCreateWithRegisterModel
     */
    minLoadCapacity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SaleRequestFormCreateWithRegisterModel
     */
    maxLoadCapacity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SaleRequestFormCreateWithRegisterModel
     */
    minMaxLoadCapacity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SaleRequestFormCreateWithRegisterModel
     */
    maxMaxLoadCapacity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SaleRequestFormCreateWithRegisterModel
     */
    minFlightTime?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SaleRequestFormCreateWithRegisterModel
     */
    maxFlightTime?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SaleRequestFormCreateWithRegisterModel
     */
    drivingEquipment?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SaleRequestFormCreateWithRegisterModel
     */
    fuelTypeId?: number | null;
}

export function SaleRequestFormCreateWithRegisterModelFromJSON(json: any): SaleRequestFormCreateWithRegisterModel {
    return SaleRequestFormCreateWithRegisterModelFromJSONTyped(json, false);
}

export function SaleRequestFormCreateWithRegisterModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaleRequestFormCreateWithRegisterModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'withRegister': json['withRegister'],
        'renterUser': RenterCompanyCreateModelFromJSON(json['renterUser']),
        'subCategoryId': !exists(json, 'subCategoryId') ? undefined : json['subCategoryId'],
        'subCategoryOther': !exists(json, 'subCategoryOther') ? undefined : json['subCategoryOther'],
        'brand': !exists(json, 'brand') ? undefined : json['brand'],
        'minProductionYear': !exists(json, 'minProductionYear') ? undefined : json['minProductionYear'],
        'maxProductionYear': !exists(json, 'maxProductionYear') ? undefined : json['maxProductionYear'],
        'minPrice': !exists(json, 'minPrice') ? undefined : json['minPrice'],
        'maxPrice': !exists(json, 'maxPrice') ? undefined : json['maxPrice'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'districtId': !exists(json, 'districtId') ? undefined : json['districtId'],
        'minOperatingWeight': !exists(json, 'minOperatingWeight') ? undefined : json['minOperatingWeight'],
        'maxOperatingWeight': !exists(json, 'maxOperatingWeight') ? undefined : json['maxOperatingWeight'],
        'minOperationHour': !exists(json, 'minOperationHour') ? undefined : json['minOperationHour'],
        'maxOperationHour': !exists(json, 'maxOperationHour') ? undefined : json['maxOperationHour'],
        'minCarryingCapacity': !exists(json, 'minCarryingCapacity') ? undefined : json['minCarryingCapacity'],
        'maxCarryingCapacity': !exists(json, 'maxCarryingCapacity') ? undefined : json['maxCarryingCapacity'],
        'minOperatingHeight': !exists(json, 'minOperatingHeight') ? undefined : json['minOperatingHeight'],
        'maxOperatingHeight': !exists(json, 'maxOperatingHeight') ? undefined : json['maxOperatingHeight'],
        'minSpraySpeed': !exists(json, 'minSpraySpeed') ? undefined : json['minSpraySpeed'],
        'maxSpraySpeed': !exists(json, 'maxSpraySpeed') ? undefined : json['maxSpraySpeed'],
        'minTankVolume': !exists(json, 'minTankVolume') ? undefined : json['minTankVolume'],
        'maxTankVolume': !exists(json, 'maxTankVolume') ? undefined : json['maxTankVolume'],
        'minLiftingHeight': !exists(json, 'minLiftingHeight') ? undefined : json['minLiftingHeight'],
        'maxLiftingHeight': !exists(json, 'maxLiftingHeight') ? undefined : json['maxLiftingHeight'],
        'minOperationMileage': !exists(json, 'minOperationMileage') ? undefined : json['minOperationMileage'],
        'maxOperationMileage': !exists(json, 'maxOperationMileage') ? undefined : json['maxOperationMileage'],
        'minNoMinalCapacity': !exists(json, 'minNoMinalCapacity') ? undefined : json['minNoMinalCapacity'],
        'maxNoMinalCapacity': !exists(json, 'maxNoMinalCapacity') ? undefined : json['maxNoMinalCapacity'],
        'minHeight': !exists(json, 'minHeight') ? undefined : json['minHeight'],
        'maxHeight': !exists(json, 'maxHeight') ? undefined : json['maxHeight'],
        'minEnginePower': !exists(json, 'minEnginePower') ? undefined : json['minEnginePower'],
        'maxEnginePower': !exists(json, 'maxEnginePower') ? undefined : json['maxEnginePower'],
        'minMaxPower': !exists(json, 'minMaxPower') ? undefined : json['minMaxPower'],
        'maxMaxPower': !exists(json, 'maxMaxPower') ? undefined : json['maxMaxPower'],
        'minVolume': !exists(json, 'minVolume') ? undefined : json['minVolume'],
        'maxVolume': !exists(json, 'maxVolume') ? undefined : json['maxVolume'],
        'minTankCapacity': !exists(json, 'minTankCapacity') ? undefined : json['minTankCapacity'],
        'maxTankCapacity': !exists(json, 'maxTankCapacity') ? undefined : json['maxTankCapacity'],
        'minLoadCapacity': !exists(json, 'minLoadCapacity') ? undefined : json['minLoadCapacity'],
        'maxLoadCapacity': !exists(json, 'maxLoadCapacity') ? undefined : json['maxLoadCapacity'],
        'minMaxLoadCapacity': !exists(json, 'minMaxLoadCapacity') ? undefined : json['minMaxLoadCapacity'],
        'maxMaxLoadCapacity': !exists(json, 'maxMaxLoadCapacity') ? undefined : json['maxMaxLoadCapacity'],
        'minFlightTime': !exists(json, 'minFlightTime') ? undefined : json['minFlightTime'],
        'maxFlightTime': !exists(json, 'maxFlightTime') ? undefined : json['maxFlightTime'],
        'drivingEquipment': !exists(json, 'drivingEquipment') ? undefined : json['drivingEquipment'],
        'fuelTypeId': !exists(json, 'fuelTypeId') ? undefined : json['fuelTypeId'],
    };
}

export function SaleRequestFormCreateWithRegisterModelToJSON(value?: SaleRequestFormCreateWithRegisterModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'withRegister': value.withRegister,
        'renterUser': RenterCompanyCreateModelToJSON(value.renterUser),
        'subCategoryId': value.subCategoryId,
        'subCategoryOther': value.subCategoryOther,
        'brand': value.brand,
        'minProductionYear': value.minProductionYear,
        'maxProductionYear': value.maxProductionYear,
        'minPrice': value.minPrice,
        'maxPrice': value.maxPrice,
        'description': value.description,
        'districtId': value.districtId,
        'minOperatingWeight': value.minOperatingWeight,
        'maxOperatingWeight': value.maxOperatingWeight,
        'minOperationHour': value.minOperationHour,
        'maxOperationHour': value.maxOperationHour,
        'minCarryingCapacity': value.minCarryingCapacity,
        'maxCarryingCapacity': value.maxCarryingCapacity,
        'minOperatingHeight': value.minOperatingHeight,
        'maxOperatingHeight': value.maxOperatingHeight,
        'minSpraySpeed': value.minSpraySpeed,
        'maxSpraySpeed': value.maxSpraySpeed,
        'minTankVolume': value.minTankVolume,
        'maxTankVolume': value.maxTankVolume,
        'minLiftingHeight': value.minLiftingHeight,
        'maxLiftingHeight': value.maxLiftingHeight,
        'minOperationMileage': value.minOperationMileage,
        'maxOperationMileage': value.maxOperationMileage,
        'minNoMinalCapacity': value.minNoMinalCapacity,
        'maxNoMinalCapacity': value.maxNoMinalCapacity,
        'minHeight': value.minHeight,
        'maxHeight': value.maxHeight,
        'minEnginePower': value.minEnginePower,
        'maxEnginePower': value.maxEnginePower,
        'minMaxPower': value.minMaxPower,
        'maxMaxPower': value.maxMaxPower,
        'minVolume': value.minVolume,
        'maxVolume': value.maxVolume,
        'minTankCapacity': value.minTankCapacity,
        'maxTankCapacity': value.maxTankCapacity,
        'minLoadCapacity': value.minLoadCapacity,
        'maxLoadCapacity': value.maxLoadCapacity,
        'minMaxLoadCapacity': value.minMaxLoadCapacity,
        'maxMaxLoadCapacity': value.maxMaxLoadCapacity,
        'minFlightTime': value.minFlightTime,
        'maxFlightTime': value.maxFlightTime,
        'drivingEquipment': value.drivingEquipment,
        'fuelTypeId': value.fuelTypeId,
    };
}

